import { render, staticRenderFns } from "./SortItem.vue?vue&type=template&id=2932da26&scoped=true"
import script from "./SortItem.vue?vue&type=script&lang=js"
export * from "./SortItem.vue?vue&type=script&lang=js"
import style0 from "./SortItem.vue?vue&type=style&index=0&id=2932da26&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932da26",
  null
  
)

export default component.exports